// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite_revision".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite_revision" table (1:1 with a DB row, on the wire). */
export const micrositeRevisionAtomSchema = z.object({
    id: z.string(),
    micrositeId: z.string(),
    organizationId: z.string(),
    label: z.string().nullable(),
    pages: z.unknown(),
    theme: z.unknown(),
    createdBy: z.string(),
    promptId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=micrositeRevision.js.map